import React from "react";

import { Box, Grid, Skeleton } from "@mui/material";

function VideoSkeleton() {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Box
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[800],
          borderRadius: 2,
          overflow: "hidden",
          height: 320,
        }}
      >
        <Skeleton variant="rectangular" height={200} />
        <Box sx={{ p: 2 }}>
          <Skeleton variant="text" width="80%" height={20} />
          <Skeleton variant="text" width="60%" height={16} sx={{ mt: 1 }} />
        </Box>
      </Box>
    </Grid>
  );
}

function LoadingSkeletons() {
  return (
    <>
      <VideoSkeleton />
      <VideoSkeleton />
      <VideoSkeleton />
      <VideoSkeleton />
      <VideoSkeleton />
      <VideoSkeleton />
      <VideoSkeleton />
      <VideoSkeleton />
    </>
  );
}

export { VideoSkeleton, LoadingSkeletons };
